/* ============================================================
   EPIC · Menú inteligente (reskin del drawer Dawn)
   Reutiliza los MISMOS links del menú. Añade, sin tocar la lógica nativa:
   · Accesos rápidos (tiles) arriba.
   · Buscador que filtra los items en vivo (inteligente, tolera acentos).
   · Íconos por sección (deducidos del texto).
   Idempotente; se re-aplica en el editor (shopify:section:load).
   ============================================================ */
(function () {
  if (window.__epicMenu) return; window.__epicMenu = true;

  function svg(p, vb) { return '<svg viewBox="' + (vb || '0 0 24 24') + '" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var IC = {
    home:  svg('<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M9 21v-6h6v6"/>'),
    bag:   svg('<path d="M6 7h12l-1 14H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/>'),
    flask: svg('<path d="M9 3h6M10 3v6.5L4 20h16L14 9.5V3M8.5 14h7"/>'),
    app:   svg('<rect x="6" y="2" width="12" height="20" rx="3"/><path d="M11 18h2"/>'),
    trophy:svg('<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.7V17c0 .6-.5 1-1 1.2C7.8 18.8 7 20.2 7 22M14 14.7V17c0 .6.5 1 1 1.2C16.2 18.8 17 20.2 17 22M18 2H6v7a6 6 0 0 0 12 0V2Z"/>'),
    layers:svg('<path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="m2 17 10 5 10-5"/><path d="m2 12 10 5 10-5"/>'),
    info:  svg('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    chat:  svg('<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.2A8.4 8.4 0 0 1 12 3a8.5 8.5 0 0 1 9 8.5z"/>'),
    book:  svg('<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>'),
    gift:  svg('<rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9M12 8v13M12 8S11 3 8.5 3a2.5 2.5 0 0 0 0 5H12zM12 8s1-5 3.5-5a2.5 2.5 0 0 1 0 5H12z"/>'),
    dot:   svg('<circle cx="12" cy="12" r="3.2"/>')
  };
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function iconFor(text) {
    var t = norm(text);
    if (/inicio|home/.test(t)) return IC.home;
    if (/tienda|product|comprar|shop|suplement/.test(t)) return IC.bag;
    if (/paquete|protocolo|bundle|combo|stack/.test(t)) return IC.layers;
    if (/ciencia|blog|articulo|aprende/.test(t)) return IC.flask;
    if (/app|progreso|mi epic|cuenta|herramienta/.test(t)) return IC.app;
    if (/atleta|embajador|programa/.test(t)) return IC.trophy;
    if (/nosotros|about|historia|marca/.test(t)) return IC.info;
    if (/contacto|ayuda|soporte|whats/.test(t)) return IC.chat;
    if (/curso|educa|education|master/.test(t)) return IC.book;
    if (/regalo|recompensa|oferta|promo|descuento/.test(t)) return IC.gift;
    return IC.dot;
  }

  function enhance() {
    var nav = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!nav || nav.__epicMenuDone) return; nav.__epicMenuDone = true;
    return; /* EPIC: drawer NATIVO limpio — enhancer desactivado (sin tiles ni buscador). El menú móvil queda en su forma nativa, limpia y premium. */
    /* INERTE A PROPÓSITO: este enhancer es legacy y NO debe tocar el menú real (epic-md).
       Apunta a una clase inexistente para que SIEMPRE haga bail aquí y el menú quede nativo. */
    var ul = nav.querySelector('.menu-drawer__menu'); if (!ul) return;

    /* Accesos rápidos (mismos destinos clave del sitio) */
    var quick = document.createElement('div');
    quick.className = 'epic-mnu__quick';
    quick.innerHTML =
      '<a class="epic-mnu__tile" href="/"><span>' + IC.home + '</span>Inicio</a>' +
      '<a class="epic-mnu__tile" href="/collections/all"><span>' + IC.bag + '</span>Productos</a>' +
      '<a class="epic-mnu__tile" href="/blogs/ciencia"><span>' + IC.flask + '</span>Ciencia</a>' +
      '<a class="epic-mnu__tile" href="/pages/tu-progreso"><span>' + IC.app + '</span>Mi App</a>';

    nav.insertBefore(quick, ul);

    /* Íconos por sección en los items de 1er nivel */
    Array.prototype.forEach.call(ul.children, function (li) {
      var item = li.querySelector(':scope > a.epic-md__card, :scope > details > summary.epic-md__card');
      if (!item || item.__ico) return; item.__ico = true;
      var label = (item.textContent || '').trim();
      var ico = document.createElement('span');
      ico.className = 'epic-mnu__ico'; ico.innerHTML = iconFor(label);
      item.insertBefore(ico, item.firstChild);
    });

  }

  function boot() { try { enhance(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () {
    var nav = document.querySelector('#menu-drawer .menu-drawer__navigation'); if (nav) nav.__epicMenuDone = false; boot();
  });
})();
